export default {
  title: 'Record',
};
